import { SVGAttributes } from "react";

const AGNTHubIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="1080"
      height="1080"
      viewBox="0 0 1080 1080"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M349.924 422.864C341.316 426.129 332.97 429.917 324.937 434.214C324.741 430.44 324.636 426.665 324.636 422.864H349.924Z"
        fill="url(#paint0_linear_605_299)"
      />
      <path
        d="M504 604.605C497.482 621.416 478.556 629.762 461.746 623.231C421.803 607.714 387.699 580.885 363.117 545.606C353.517 531.826 345.641 517.145 339.58 501.784C357.213 489.284 377.655 480.507 399.768 476.602C414.489 515.264 444.948 546.651 485.387 562.351C502.197 568.869 510.531 587.795 504 604.605Z"
        fill="url(#paint1_linear_605_299)"
      />
      <path
        d="M539.5 208V273.308C460.699 273.308 395.953 334.567 390.336 411.944C376.36 414.282 362.855 417.965 349.924 422.863H324.636C324.636 304.395 421.018 208 539.5 208Z"
        fill="url(#paint2_linear_605_299)"
      />
      <path
        d="M754.364 422.863H689.056C689.056 340.405 621.958 273.308 539.5 273.308V208C657.969 208 754.364 304.395 754.364 422.863Z"
        fill="url(#paint3_linear_605_299)"
      />
      <path
        d="M754.364 422.864C754.364 467.038 741.054 509.488 715.872 545.617C691.29 580.883 657.186 607.725 617.244 623.229C613.364 624.731 609.367 625.449 605.436 625.449C592.348 625.449 580.005 617.534 574.989 604.603C568.458 587.793 576.792 568.879 593.602 562.349C651.596 539.83 689.056 485.089 689.056 422.864H754.364Z"
        fill="url(#paint4_linear_605_299)"
      />
      <path
        d="M868 623.872C868 742.354 771.605 838.735 653.136 838.735V773.427C735.594 773.427 802.692 706.343 802.692 623.872H868Z"
        fill="url(#paint5_linear_605_299)"
      />
      <path
        d="M688.664 411.944C688.925 415.549 689.056 419.193 689.056 422.863C689.056 441.685 685.621 459.828 679.234 476.599C670.757 475.097 662.031 474.313 653.136 474.313V409.005C665.232 409.005 677.105 410.011 688.664 411.944Z"
        fill="url(#paint6_linear_605_299)"
      />
      <path
        d="M868 623.868H802.692C802.692 573.516 777.679 528.897 739.422 501.782C747.898 480.321 752.862 457.568 754.064 434.214C821.801 470.408 868 541.842 868 623.868Z"
        fill="url(#paint7_linear_605_299)"
      />
      <path
        d="M653.136 409.005V474.313C618.85 474.313 586.601 485.598 559.877 506.941C545.783 518.2 525.237 515.901 513.978 501.808C502.732 487.714 505.018 467.168 519.111 455.922C556.977 425.658 604.573 409.005 653.136 409.005Z"
        fill="url(#paint8_linear_605_299)"
      />
      <path
        d="M425.864 409.005V474.313C343.393 474.313 276.308 541.397 276.308 623.868H211C211 505.386 307.382 409.005 425.864 409.005Z"
        fill="url(#paint9_linear_605_299)"
      />
      <path
        d="M565.01 501.808C553.75 515.901 533.205 518.2 519.124 506.941C492.4 485.598 460.151 474.313 425.864 474.313V409.005C474.414 409.005 522.011 425.658 559.876 455.909C573.97 467.168 576.269 487.714 565.01 501.808Z"
        fill="url(#paint10_linear_605_299)"
      />
      <path
        d="M425.864 773.427V838.735C307.382 838.735 211 742.354 211 623.872H276.308C276.308 706.343 343.393 773.427 425.864 773.427Z"
        fill="url(#paint11_linear_605_299)"
      />
      <path
        d="M539.5 806.159C506.52 826.796 467.557 838.735 425.864 838.735V773.427C447.716 773.427 468.497 768.711 487.228 760.248C502.026 778.22 519.686 793.764 539.5 806.159Z"
        fill="url(#paint12_linear_605_299)"
      />
      <path
        d="M640.728 623.87C640.728 675.594 622.35 723.125 591.786 760.246C571.566 751.129 553.737 737.637 539.5 720.983C561.888 694.834 575.42 660.9 575.42 623.87C575.42 615.289 574.688 606.694 573.251 598.321C570.195 580.545 582.133 563.656 599.897 560.6C617.687 557.556 634.563 569.481 637.619 587.258C639.683 599.275 640.728 611.592 640.728 623.87Z"
        fill="url(#paint13_linear_605_299)"
      />
      <path
        d="M653.137 773.426V838.734C534.655 838.734 438.273 742.353 438.273 623.871C438.273 611.593 439.318 599.276 441.382 587.259C444.438 569.482 461.314 557.544 479.104 560.6C496.868 563.657 508.806 580.546 505.75 598.309C504.313 606.695 503.581 615.289 503.581 623.871C503.581 706.342 570.666 773.426 653.137 773.426Z"
        fill="url(#paint14_linear_605_299)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_605_299"
          x1="442.504"
          y1="619.924"
          x2="352.379"
          y2="455.779"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E0BB1E" stop-opacity="0" />
          <stop offset="1" stop-color="#E0BB1E" stop-opacity="0.25" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_605_299"
          x1="459.107"
          y1="610.81"
          x2="368.982"
          y2="446.677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E0BB1E" stop-opacity="0" />
          <stop offset="1" stop-color="#E0BB1E" stop-opacity="0.25" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_605_299"
          x1="353.842"
          y1="379.577"
          x2="498.826"
          y2="237.637"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E0BB1E" stop-opacity="0.25" />
          <stop offset="1" stop-color="#E0BB1E" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_605_299"
          x1="580.501"
          y1="238.107"
          x2="725.628"
          y2="382.072"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E0BB1E" stop-opacity="0.5" />
          <stop offset="1" stop-color="#E0BB1E" stop-opacity="0.75" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_605_299"
          x1="714.187"
          y1="439.883"
          x2="611.431"
          y2="625.645"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E0BB1E" stop-opacity="0.75" />
          <stop offset="1" stop-color="#E0BB1E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_605_299"
          x1="838.024"
          y1="664.298"
          x2="695.221"
          y2="808.837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#665BFF" stop-opacity="0.5" />
          <stop offset="1" stop-color="#665BFF" stop-opacity="0.75" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_605_299"
          x1="677.81"
          y1="450.031"
          x2="825.55"
          y2="597.484"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#665BFF" stop-opacity="0.25" />
          <stop offset="1" stop-color="#665BFF" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_605_299"
          x1="691.747"
          y1="436.069"
          x2="839.486"
          y2="583.521"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#665BFF" stop-opacity="0.25" />
          <stop offset="1" stop-color="#665BFF" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_605_299"
          x1="506.833"
          y1="461.539"
          x2="653.136"
          y2="461.539"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#665BFF" stop-opacity="0" />
          <stop offset="1" stop-color="#665BFF" stop-opacity="0.25" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_605_299"
          x1="238.848"
          y1="584.096"
          x2="383.4"
          y2="440.131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5621" stop-opacity="0.5" />
          <stop offset="1" stop-color="#FF5621" stop-opacity="0.75" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_605_299"
          x1="425.864"
          y1="461.539"
          x2="572.154"
          y2="461.539"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5621" stop-opacity="0.75" />
          <stop offset="1" stop-color="#FF5621" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_605_299"
          x1="386.901"
          y1="811.11"
          x2="240.611"
          y2="665.395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5621" stop-opacity="0.25" />
          <stop offset="1" stop-color="#FF5621" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_605_299"
          x1="639.918"
          y1="625.53"
          x2="464.605"
          y2="808.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5621" stop-opacity="0" />
          <stop offset="1" stop-color="#FF5621" stop-opacity="0.25" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_605_299"
          x1="632.042"
          y1="617.979"
          x2="456.729"
          y2="801.129"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5621" stop-opacity="0" />
          <stop offset="1" stop-color="#FF5621" stop-opacity="0.25" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_605_299"
          x1="601.987"
          y1="809.111"
          x2="451.348"
          y2="609.699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#665BFF" stop-opacity="0.75" />
          <stop offset="1" stop-color="#665BFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AGNTHubIcon;
